import { isEmpty } from '@semios/app-platform-common'
import { DropdownButton } from 'components/DropdownButtons/DropdownButton'
import { IconGear } from 'components/icons/IconGear'
import type { StackedChartSection } from 'components/StackedChart/types'
import { translate } from 'i18n/i18n'
import type { ReactElement, ReactNode } from 'react'
import { Children, Fragment, isValidElement } from 'react'
import { useScreenSize } from 'utils/useScreenSize'

type TDropdownSettingsButtonProps = {
  options?: NonNullable<StackedChartSection['titleLink']>
  desktopOutsideMobileDropdownOptions?: ReactNode
}

type TLinkComponent = ReactElement<{ 'data-role'?: string }> | null

const extractWithDataRole = (node: ReactNode): TLinkComponent[] => {
  const result: TLinkComponent[] = []

  Children.forEach(node, (child) => {
    if (!isValidElement(child)) return

    if (child.type === Fragment) {
      result.push(...extractWithDataRole(child.props.children))

      return
    } else if ('data-role' in (child.props || {})) {
      result.push(child as TLinkComponent)
    }
  })

  return result
}

export const DropdownSettingsButton = ({
  options,
  desktopOutsideMobileDropdownOptions,
}: TDropdownSettingsButtonProps) => {
  const { isWideScreen } = useScreenSize()

  if (isEmpty(options) && !desktopOutsideMobileDropdownOptions) {
    return null
  }

  const extracted = extractWithDataRole(options)
  const modals = extracted.filter((el) => isValidElement(el) && el.props['data-role'] === 'modal')
  const menuItems = extracted.filter((el) => isValidElement(el) && el.props['data-role'] === 'menu-item')

  return (
    <>
      <DropdownButton
        leftIcon={
          <span css={{ display: 'flex', alignItems: 'center', width: '95%' }}>
            <IconGear />
          </span>
        }
        options={menuItems}
        desktopOutsideMobileDropdownOptions={desktopOutsideMobileDropdownOptions}
      >
        {isWideScreen && translate.phrases.banyanApp('Settings')}
      </DropdownButton>
      {modals?.map((modal) => modal)}
    </>
  )
}
